<template>
  <div>
    <div class="flex w-full justify-end items-center space-x-2 pr-2">
      <LikeButton :pinInitial="selectedPin" showCounter />
      <CommentButton :pinInitial="selectedPin" showCounter @click="$emit('show-comments')" />
    </div>

    <div v-if="Boolean(selectedPin?.file_id.length)" class="divider" />

    <div v-if="Boolean(selectedPin?.file_id.length)" class="px-8">
      <div class="flex space-x-4 overflow-x-auto">
        <MediaView v-for="id in selectedPin?.file_id" :key="id" class="rounded-xl cursor-pointer w-64 h-40 object-cover"
          :fileId="id" :width="240" :height="160" @click="selectedFileId = id" showFakePlay />
      </div>
    </div>

    <div class="divider" />

    <div class="flex flex-col justify-center items-center mx-2 lg:mx-8 mb-2 lg:mb-8 mt-2 lg:mt-4">
      <div v-if="authToken && !selectedPin?.approved" class="flex items-center space-x-2 mb-4">
        <p>{{ $t('adminApproval') }}</p>
        <button class="btn btn-success btn-sm" @click="instantApprove">
          {{ $t('approve') }}
        </button>
        <button class="btn btn-error btn-sm" @click="toggleDenyDialog">
          {{ $t('deny') }}
        </button>
      </div>
      <p class="mb-4">{{ $t('doYouHaveAnyQuestions') }}</p>
      <div class="flex items-center space-x-2">
        <button class="btn btn-primary text-accent" @click="toggleSubmitQuestionDialog">
          {{ $t('askQuestion') }}
        </button>
        <button class="btn btn-ghost btn-square text-accent">
          <ShareIcon class="w-6 h-6" />
        </button>
      </div>
    </div>
  </div>

  <ImageModal v-if="selectedFileId" :fileId="selectedFileId" @close="selectedFileId = ''" />
  <SubmitQuestionDialog v-if="selectedPin?._id && showQuestionDialog" :activity_id="selectedPin._id"
    @close="toggleSubmitQuestionDialog" />
  <DenyActivityDialog v-if="selectedPin?._id && showDenyDialog" :activity_id="selectedPin._id"
    @close="toggleDenyDialog" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { usePinsStore } from '@/stores/pins'
import { ShareIcon } from '@heroicons/vue/24/outline'
import { storeToRefs } from 'pinia'

import { axiosInstance } from '@/utils/axios'
import { imageUrl } from '@/utils/constants'

import CommentButton from '@/components/CommentButton.vue'
import DenyActivityDialog from '@/components/DenyActivityDialog.vue'
import ImageModal from '@/components/ImageModal.vue'
import LikeButton from '@/components/LikeButton.vue'
import MediaView from '@/components/MediaView.vue'
import SubmitQuestionDialog from '@/components/SubmitQuestionDialog.vue'

const pinsStore = usePinsStore()
const { updatePin } = pinsStore
const { selectedPin } = storeToRefs(pinsStore)

const showQuestionDialog = ref(false)
const showDenyDialog = ref(false)
const authToken = ref('')
const selectedFileId = ref('')

const emit = defineEmits<{
  (e: 'update'): void
  (e: 'show-comments'): void
}>()

onMounted(() => {
  const storedToken = sessionStorage.getItem('authToken')

  authToken.value = storedToken ? storedToken : ''
})

const instantApprove = async () => {
  try {
    if (!selectedPin.value) {
      return
    }

    const { data } = await axiosInstance.put(
      `activities/${selectedPin.value._id}`,
      {
        approved: true,
        reason: ''
      },
      {
        ...(authToken.value && { headers: { 'x-auth-token': authToken.value } })
      }
    )

    updatePin(data)
    emit('update')
  } catch (e) {
    if (e instanceof Error) {
      console.error(e.message)
    } else {
      console.error(e)
    }
  }
}

const toggleDenyDialog = () => {
  showDenyDialog.value = !showDenyDialog.value
}

const toggleSubmitQuestionDialog = () => {
  showQuestionDialog.value = !showQuestionDialog.value
}
</script>
